import { FormStep, StepType, StepTypeWithIndex } from '../types';

export function setCurrentStepByHash(
  hash: string,
  options: FormStep[],
  setCurrentStep: (step: StepTypeWithIndex) => void
) {
  if (!hash) return;
  const index = options.findIndex((opt) => `#${opt.step}` === hash);

  if (index >= 0) {
    const newStep = options[index];
    setCurrentStep({
      type: newStep.type as StepType,
      index,
      step: newStep.step,
    });
  }
}
